import { TagsTable } from './tags-table';

export { TagsTable };
